// extracted by mini-css-extract-plugin
export default {"container":"HeadOfUserList_container__TkmBR","wrapperButton":"HeadOfUserList_wrapperButton__U8oiy"};